type CampaignDestination = {
  applicationUrl: string;
  conditionsUrl: string;
  kind: "official" | "affiliate";
  adMarkup?: string;
};

// 申込先を変更する際は、conditionsUrlの特典がapplicationUrl経由でも適用されるか確認する。
export const simMnpCampaignLinks: Record<string, CampaignDestination> = {
  ahamo: {
    applicationUrl: "https://px.a8.net/svt/ejp?a8mat=4BCBRC+DXB3ZU+4TIO+626XU",
    conditionsUrl: "https://ahamo.com/special/lp/dpointcp/001.html",
    kind: "affiliate",
    // A8.netの「スマホ代見直し案内所」掲載サイト用・素材ID 018。広告コードは改変しない。
    adMarkup: '<a href="https://px.a8.net/svt/ejp?a8mat=4BCBRC+DXB3ZU+4TIO+626XU" rel="nofollow">20,000ポイントプレゼント！</a> <img border="0" width="1" height="1" src="https://www19.a8.net/0.gif?a8mat=4BCBRC+DXB3ZU+4TIO+626XU" alt="">',
  },
  uq: {
    applicationUrl: "https://shop.uqmobile.jp/shop/cashback/",
    conditionsUrl: "https://shop.uqmobile.jp/shop/cashback/",
    kind: "official",
  },
  ymobile: {
    applicationUrl: "https://www.ymobile.jp/store/sp/sim/",
    conditionsUrl: "https://www.ymobile.jp/store/sp/sim/",
    kind: "official",
  },
  linemo: {
    applicationUrl: "https://www.linemo.jp/campaign/paypaycpn_2025/",
    conditionsUrl: "https://www.linemo.jp/campaign/paypaycpn_2025/",
    kind: "official",
  },
  rakuten: {
    applicationUrl: "https://network.mobile.rakuten.co.jp/campaign/rakuten-employee/entry/vip/",
    conditionsUrl: "https://network.mobile.rakuten.co.jp/campaign/rakuten-employee/entry/vip/",
    kind: "official",
  },
};
